// extracted by mini-css-extract-plugin
module.exports = {"markdown":"Content_markdown__urIeA","footer":"Content_footer__UG8y_","footerAction":"Content_footerAction__2moLi"};